import {
  EnrollmentSyncRequest,
  StudentModuleEnrollmentSyncModel,
} from "../api/APIClient";
import { assessmentEnrollmentClient } from "../api/clients";
import { unwrap } from "../api/errors";

export async function findStudentEnrollment(
  studentID: string,
  moduleID: string,
  qualificationModuleID: string,
): Promise<StudentModuleEnrollmentSyncModel[]> {
  const response =
    await assessmentEnrollmentClient.listStudentModuleEnrollmentsForSync(
      new EnrollmentSyncRequest({
        userIDs: [studentID],
        moduleIDs: [moduleID],
        skip: 0,
        take: 2000,
      }),
    );
  const enrollments = unwrap(response) ?? [];
  if (enrollments.length === 2000) {
    throw new Error(
      "This learner has too many matching enrollments to verify safely. Review module enrollment.",
    );
  }
  return enrollments.filter(
    (enrollment) => enrollment.qualificationModuleID === qualificationModuleID,
  );
}
